import React from "react";
import utils from "fantastic/lib/utils";

const NONE = "none";
const { px, proc, url } = utils;

const styles = (props, rules) => {
  let styles = props.styles || {};

  if (props.meta && props.meta.type === "ITEM") styles.transition = "all 300ms";

  if (rules.includes("background")) {
    const {
      css_background,
      css_background_image,
      css_background_position,
      css_background_repeat,
      background,
      background_image,
      background_position,
      background_repeat,
      preview_mode,
      theme_mode,
      preview
    } = props;


    styles.backgroundColor = css_background || background;
    if ((css_background_image && css_background_image !== NONE) || (background_image && background_image !== NONE)) {
      styles.backgroundImage = url(css_background_image || background_image);
      if (css_background_repeat || background_repeat)
        styles.backgroundRepeat = css_background_repeat || background_repeat;
      styles.backgroundPosition =
        css_background_position || background_position;
    }

    if(preview && props.meta.type === "SECTION" && preview_mode !== theme_mode) {
      styles.backgroundColor = 'transparent';
    }
  }

  if (rules.includes("height")) {
    const { height } = props;
    styles.height = px(height);
  }

  if (rules.includes("width")) {
    const { width } = props;
    styles.width = px(width);
  }

  if (rules.includes("width:%")) {
    const { width } = props;
    styles.width = proc(width);
  }

  if (rules.includes("color")) {
    const { css_color } = props;
    styles.color = css_color;
  }

  if (rules.includes("font")) {
    const { font_family, font_size, font_weight, font_style, text_decoration, strike_through } = props;
    styles.fontFamily = font_family;
    styles.fontSize = font_size;
    styles.fontWeight = font_weight;
    styles.fontStyle = font_style;
    const decorations = [];
    if (text_decoration && text_decoration !== "none") decorations.push(text_decoration);
    if (strike_through && strike_through !== "none") decorations.push(strike_through);
    styles.textDecoration = decorations.join(" ") || "none";
  }

  if (rules.includes("border")) {
    const { css_border_radius, css_border_color, css_border_width, css_border_style } = props;
    styles.borderRadius = px(css_border_radius);
    if (css_border_color && css_border_color !== "") {
      styles.borderStyle = css_border_style || "solid";
      styles.borderWidth = px(css_border_width) || "1px";
      styles.borderColor = css_border_color;
    }
  }

  function pxBorderRadius(val) {
    if (!val) return '';
    return val
      .split(' ')
      .map(v => v.trim())
      .filter(v => v !== '')
      .map(v => `${v}px`)
      .join(' ');
  }

  if (rules.includes("border-section")) {
    const { border_radius, border_color, border_width, border_style } = props;
    if (border_radius) {
      styles.borderRadius = pxBorderRadius(border_radius);
      
      const radiusValues = border_radius
        .toString()
        .split(' ')
        .map(v => v.trim())
        .filter(v => v !== '')
        .map(v => parseFloat(v));
      
      if (radiusValues.length === 4) {
        // top-left, top-right, bottom-right, bottom-left
        const topRadius = Math.max(radiusValues[0], radiusValues[1]);
        const bottomRadius = Math.max(radiusValues[2], radiusValues[3]);
        styles.paddingTop = px(topRadius / 2);
        styles.paddingBottom = px(bottomRadius / 2);
      } else {
        // одно значение для всех углов
        const radius = radiusValues[0] || 0;
        styles.paddingTop = px(radius / 2);
        styles.paddingBottom = px(radius / 2);
      }
    }

    if (border_color && border_color !== "") {
      styles.borderStyle = border_style || "none";
      styles.borderWidth = px(border_width) || "0px";
      styles.borderColor = border_color;
    }
  }

  if (rules.includes("padding")) {
    const {
      css_padding_bottom,
      css_padding_left,
      css_padding_right,
      css_padding_top
    } = props;

    styles.paddingTop = px(css_padding_top);
    styles.paddingLeft = px(css_padding_left);
    styles.paddingRight = px(css_padding_right);
    styles.paddingBottom = px(css_padding_bottom);
  }

  if (rules.includes("text-align")) {
    const { text_align } = props;
    styles.textAlign = text_align;
  }

  return styles;
};

export default (...args) => Component => {
  const rules = args.length === 0 ? ["background"] : args;
  const StylesComponent = props => {
    return <Component {...props} style={styles(props, rules)} />;
  };

  return StylesComponent;
};
